import { render, staticRenderFns } from "./WalletInfo.vue?vue&type=template&id=080bc55e&scoped=true"
import script from "./WalletInfo.vue?vue&type=script&lang=ts"
export * from "./WalletInfo.vue?vue&type=script&lang=ts"
import style0 from "./WalletInfo.vue?vue&type=style&index=0&id=080bc55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080bc55e",
  null
  
)

export default component.exports